import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SiteNavLinks } from '../components/SiteNavLinks';
import { supabase, GuestbookEntryRow } from '../lib/supabase';
function formatDate(iso: string) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).toLowerCase();
  } catch {
    return '';
  }
}
export function Guestbook() {
  const [entries, setEntries] = useState<GuestbookEntryRow[]>([]);
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const fetchEntries = async () => {
    setIsLoading(true);
    const {
      data,
      error
    } = await supabase.from('guestbook_entries').select('*').order('created_at', {
      ascending: false
    });
    if (error) {
      setErrorMsg(`could not load guestbook — ${error.message}`);
      setEntries([]);
    } else {
      setEntries(data || []);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchEntries();
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg('');
    const trimmedMsg = message.trim();
    if (!trimmedMsg) return;
    setIsSubmitting(true);
    const trimmedName = name.trim() || 'anon';
    const {
      error
    } = await supabase.from('guestbook_entries').insert([{
      name: trimmedName,
      message: trimmedMsg
    }]);
    if (error) {
      setErrorMsg(`could not save entry — ${error.message}`);
      setIsSubmitting(false);
      return;
    }
    setName('');
    setMessage('');
    setIsSubmitting(false);
    // Refresh the list so the new entry appears immediately
    await fetchEntries();
  };
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-203" data-mp="1phachx3ysrsj">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-204" data-mp="w418toguvrwd">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-205" data-mp="10uhjx1x7f1fk">
          lennon cripe
        </Link>

        <SiteNavLinks data-id="element-206" data-mp="15tkq4pox7dp4" />

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-207" data-mp="15udpv6pgp2xr">
          contact
        </a>
      </header>

      {/* Sign form */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-208" data-mp="1fs1my3ajimj3">
        <p className="mb-4 font-bold lowercase" data-id="element-209" data-mp="1jtdeiecz5htx">sign the guestbook</p>

        <form onSubmit={handleSubmit} className="flex w-full max-w-md flex-col gap-4" data-id="element-210" data-mp="1jskfjzk9bwmc">
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="name (optional)" disabled={isSubmitting} className="border-b border-black bg-transparent py-1 text-black placeholder-black/40 focus:outline-none disabled:opacity-50" data-id="element-211" data-mp="3hlhovwc2vntd" />

          <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="leave a message" rows={3} required disabled={isSubmitting} className="resize-none border-b border-black bg-transparent py-1 text-black placeholder-black/40 focus:outline-none disabled:opacity-50" data-id="element-212" data-mp="34amibqaf7z83" />

          <button type="submit" disabled={isSubmitting} className="self-start lowercase text-black hover:opacity-60 disabled:opacity-40" data-id="element-213" data-mp="3nyvlswhezrmw">
            {isSubmitting ? 'signing...' : 'sign'}
          </button>
        </form>

        {errorMsg && <p className="mt-3 lowercase text-black/50" data-id="element-214" data-mp="27lexkkhmlu58">{errorMsg}</p>}
      </section>

      {/* Entries */}
      <section className="mt-16 flex w-full flex-col items-start gap-6 text-sm md:mt-20" data-id="element-215" data-mp="3vi39kxq7xzzi">
        <p className="font-bold lowercase" data-id="element-216" data-mp="435phpn47my6">entries</p>

        {isLoading ? <p className="lowercase text-black/50" data-id="element-217" data-mp="450990mnh90o">loading...</p> : errorMsg ? <p className="lowercase text-black/50" data-id="element-218" data-mp="3mizndkvr94gs">{errorMsg}</p> : entries.length === 0 ? <p className="lowercase" data-id="element-219" data-mp="3qgnox6rydvhn">no entries yet.</p> : entries.map(entry => <div key={entry.id} className="flex w-full max-w-md flex-col items-start gap-1" data-id="element-220" data-mp="i0u5ok68m5ww">
              <p className="font-bold lowercase" data-id="element-221" data-mp="92rz7p3qil28">
                {entry.name}
                <span className="ml-2 font-normal text-black/40" data-id="element-222" data-mp="e1bnvx9pqaya">
                  {formatDate(entry.created_at)}
                </span>
              </p>
              <p className="lowercase" data-id="element-223" data-mp="2trobzegfc5j4">{entry.message}</p>
            </div>)}
      </section>

      <div className="h-24" data-id="element-224" data-mp="2ysvo1pplnqvl" />
    </main>;
}